import { makeStyles } from '@mui/styles';
import { isNil } from 'lodash';
import React from 'react';

import NewComponent from './../../components/editor/components/NewComponent';
import { useFormSelector } from '../../../custom-hooks';
import { getUITA, isTrue } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import {
  getEntityTranslation,
  getEvaluatedExpression,
} from '../../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    '& div[class*="MuiAccordionSummary-root"]:hover': {
      background: 'transparent',
    },
  },
});

const SSEditorPanel = ({ children, id, index, entityName }) => {
  const classes = useStyles();
  const title = useFormSelector(getEntityTranslation, { id });
  const header = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.HEADER,
    defaultValue: true,
  });
  const showHeader = isTrue(header) && !isNil(title);

  return (
    <div className={classes.root} ui-ta={getUITA('FormPart', 'SSPanel', entityName)}>
      <Accordion showHeader={showHeader} title={title} expanded>
        {!children.length && <NewComponent controlParentId={id} previousControlId="" />}
        {children}
      </Accordion>
    </div>
  );
};

export default SSEditorPanel;
